import Input from 'b2b-ui-components-lib/lib/components/input';
import { IFORM } from 'featureLib/FormBuilder';
import { alphaNumericValidatorWithSpecialCharacters, emailValidaotr, mobileValidator, customCompanyValidator, customNameValidator } from 'common/utils/validator';

export const CUSTOMER_DETAILS_FORM_CONFIG: IFORM = {
  companyName: {
    key: 'companyName',
    isMandatory: true,
    value: '',
    label: 'Company Name',
    className: 'flg-lg-6 flg-md-6 flg-sm-12',
    validator: customCompanyValidator,
    element: { type: Input, props: { minlength: 3, maxlength: 30 } }
  },
  fullName: {
    key: 'fullName',
    isMandatory: true,
    value: '',
    label: 'Full Name',
    className: 'flg-lg-6 flg-md-6 flg-sm-12',
    validator: customNameValidator,
    element: { type: Input, props: { minlength: 3, maxlength: 30 } }
  },
  phoneNumber: {
    key: 'phoneNumber',
    isMandatory: true,
    value: '',
    label: 'Mobile',
    className: 'flg-lg-6 flg-md-6 flg-sm-12 mobile_field',
    validator: mobileValidator,
    element: { type: Input, props: { maxlength: 10 } }
  },
  emailAddress: {
    key: 'emailAddress',
    isMandatory: true,
    value: '',
    label: 'Email Address',
    className: 'flg-lg-6 flg-md-6 flg-sm-12 email_field',
    validator: emailValidaotr,
    element: { type: Input }
  },
  otp: {
    key: 'otp',
    isMandatory: true,
    value: '',
    label: 'OTP',
    className: 'flg-lg-6 flg-md-6 flg-sm-12 otp-field',
    hide: true,
    element: { type: Input }
  }
};
